module.exports = __webpack_public_path__ + "static/media/cocorobo__logo.b7e1fbbf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cocorobo__logo.svg
// module id = 503
// module chunks = 0